export class FreeZoneSettings {
  private _leftWidthInMillimeters: number;
  private _leftUseAsMaximum: boolean;
  private _rightWidthInMillimeters: number;
  private _rightUseAsMaximum: boolean;
  private _inBetweenWidthInMillimeters: number;
  private _inBetweenUseAsMaximum: boolean;

  public constructor(
    leftWidthInMillimeters: number,
    leftUseAsMaximum: boolean,
    rightWidthInMillimeters: number,
    rightUseAsMaximum: boolean,
    inBetweenWidthInMillimeters: number,
    inBetweenUseAsMaximum: boolean
  ) {
    this._leftWidthInMillimeters = leftWidthInMillimeters;
    this._leftUseAsMaximum = leftUseAsMaximum;
    this._rightWidthInMillimeters = rightWidthInMillimeters;
    this._rightUseAsMaximum = rightUseAsMaximum;
    this._inBetweenWidthInMillimeters = inBetweenWidthInMillimeters;
    this._inBetweenUseAsMaximum = inBetweenUseAsMaximum;
  }

  public get leftWidthInMillimeters(): number {
    return this._leftWidthInMillimeters;
  }

  public set leftWidthInMillimeters(value: number) {
    this._leftWidthInMillimeters = value;
  }

  public get leftUseAsMaximum(): boolean {
    return this._leftUseAsMaximum;
  }

  public set leftUseAsMaximum(value: boolean) {
    this._leftUseAsMaximum = value;
  }

  public get rightWidthInMillimeters(): number {
    return this._rightWidthInMillimeters;
  }

  public set rightWidthInMillimeters(value: number) {
    this._rightWidthInMillimeters = value;
  }

  public get rightUseAsMaximum(): boolean {
    return this._rightUseAsMaximum;
  }

  public set rightUseAsMaximum(value: boolean) {
    this._rightUseAsMaximum = value;
  }

  public get inBetweenWidthInMillimeters(): number {
    return this._inBetweenWidthInMillimeters;
  }

  public set inBetweenWidthInMillimeters(value: number) {
    this._inBetweenWidthInMillimeters = value;
  }

  public get inBetweenUseAsMaximum(): boolean {
    return this._inBetweenUseAsMaximum;
  }

  public set inBetweenUseAsMaximum(value: boolean) {
    this._inBetweenUseAsMaximum = value;
  }

  public toJSON(): JSON {
    return {
      leftWidthInMillimeters: this._leftWidthInMillimeters,
      leftUseAsMaximum: this._leftUseAsMaximum,
      rightWidthInMillimeters: this._rightWidthInMillimeters,
      rightUseAsMaximum: this._rightUseAsMaximum,
      inBetweenWidthInMillimeters: this._inBetweenWidthInMillimeters,
      inBetweenUseAsMaximum: this._inBetweenUseAsMaximum
    } as any as JSON;
  }

  public static fromJSON(json: any): FreeZoneSettings {
    return new FreeZoneSettings(json.leftWidthInMillimeters, json.leftUseAsMaximum, json.rightWidthInMillimeters, json.rightUseAsMaximum, json.inBetweenWidthInMillimeters, json.inBetweenUseAsMaximum);
  }
}
